import { TextInput } from '../../input/TextInput'
import { InputDate } from '../../input/inputDate/InputDate'
import { SelectOptionInput } from '../../input/selectOptionInput/SelectOptionInput'

import {
  ConfirmDetail,
  ConfirmDetailType,
  ConfirmLayout,
} from '../../../types/confirm/confirm'
import { toLocalDateTime } from '../../../utils/dateUtils'

type ConfirmDetailFieldProps = {
  detail: ConfirmDetail
  layout: ConfirmLayout
  value: string
  onDetailChange: (key: string, value: string) => void
}

export function ConfirmDetailField({
  detail,
  layout,
  value,
  onDetailChange,
}: ConfirmDetailFieldProps) {
  const isDetails = layout === ConfirmLayout.DETAILS
  const fieldClassName = isDetails
    ? 'confirm-detail-field confirm-detail-field-block'
    : 'confirm-detail-field'

  if (
    detail.type === ConfirmDetailType.SELECT &&
    detail.key &&
    detail.options
  ) {
    return (
      <div className={fieldClassName}>
        <label>{detail.label}</label>
        <SelectOptionInput
          showPlaceholder={false}
          value={value}
          list={detail.options}
          name={detail.key}
          onChange={(_, nextValue) => onDetailChange(detail.key!, nextValue)}
        />
      </div>
    )
  }

  if (detail.type === ConfirmDetailType.TEXT && detail.key) {
    return (
      <div className={fieldClassName}>
        <TextInput
          name={detail.key}
          label={detail.label}
          value={value}
          onChange={(_, nextValue) => onDetailChange(detail.key!, nextValue)}
        />
      </div>
    )
  }

  if (detail.type === ConfirmDetailType.DATE && detail.key) {
    return (
      <div className={`${fieldClassName} confirm-detail-field-date`}>
        <label>{detail.label}</label>
        <InputDate
          name={detail.key}
          value={new Date(value)}
          className="input-date flex-sm-grow-0 confirm-detail-field-date-input"
          onChange={(_, nextValue) =>
            onDetailChange(detail.key ?? '', toLocalDateTime(nextValue))
          }
        />
      </div>
    )
  }

  if (isDetails) {
    return (
      <div className="confirm-detail-line flex-sm-row align-items-sm-baseline justify-content-sm-between gap-sm-3">
        <span className="confirm-detail-label">{detail.label}</span>
        <span className="confirm-detail-value text-sm-end">{detail.value}</span>
      </div>
    )
  }

  return (
    <div className="when">
      {detail.label}: {detail.value}
    </div>
  )
}
